import React from "react"

const LoadingSpinner = ()=>{

    return (
        <div className="loader-container">
            <span className="loader"></span>
        </div>
    )
}
export default LoadingSpinner